import { useContext, useEffect, useRef } from 'react';
import { store } from 'components/Store';
import useNumberOfUnseenItems from 'components/Dashboard/hooks/useNumberOfUnseenItems';

const useLoadUnseenCounts = () => {
  const { state } = useContext(store) as unknown as { state: { search: { list: object | string | null } } };
  const { list } = state.search;
  const { numberOfUnseenItems } = useNumberOfUnseenItems();
  const loadCounts = useRef(numberOfUnseenItems);
  loadCounts.current = numberOfUnseenItems;

  useEffect(() => {
    if (!list) return;
    const controller = new AbortController();
    loadCounts.current(controller);
    return () => controller.abort('Unseen counts cancelled.');
  }, [list]);
};

export default useLoadUnseenCounts;
